import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {authGuard} from 'src/app/core/guards/auth.guard';
import {AmministrazioneUserPageComponent} from './amministrazione-user-page/amministrazione-user-page.component';
import {AmministrazioneEntiPageComponent} from './amministrazione-enti-page/amministrazione-enti-page.component';
import { UtentiPageDettaglioComponent } from './amministrazione-user-dettaglio-page/amministrazione-user-dettaglio-page.component';
const amministrazioneRoutes: Routes = [
  {
    path: 'users',
    component: AmministrazioneUserPageComponent,
    children: [],
  },
  {
    path: 'users/:id',
    component: UtentiPageDettaglioComponent,
    children: [],
  },
  {
    path: 'enti',
    component: AmministrazioneEntiPageComponent,
    children: [],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(amministrazioneRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AmministrazioneRoutingModule {
}
